<template>
  <el-row style="margin-top: 4vh">
    <el-col :lg="18">
      <p class="doc">Archivos</p>
    </el-col>
    <el-col :lg="6">
      <el-button class="crear" @click="toggleA">Nuevo Elemento</el-button>
    </el-col>
  </el-row>
  <el-divider style="margin-top: 0; background-color: #000d5a"></el-divider>
  <el-table class="table" stripe :data="elementos" max-height="490">
    <el-table-column label="Título" prop="titulo"> </el-table-column>
    <!--<el-table-column label="Descripción" prop="descripcion">
      <template #default="scope">
        <el-tooltip placement="top" effect=light>
          <template #content>
            {{scope.row.descripcion}}
          </template>
          <img src="@/assets/Show.png" class="verDes" alt="">
        </el-tooltip>
      </template>
    </el-table-column>
    -->
    <el-table-column label="Formato" prop="tipo"> </el-table-column>
    <el-table-column label="Fecha" prop="fecha">
      <template #default="scope">
        {{ dia = new Date(scope.row.fecha.seconds *1000).getUTCDate()}} / 
        {{ mes = new Date(scope.row.fecha.seconds *1000).getMonth() +1}} /
        {{ year = new Date(scope.row.fecha.seconds *1000).getFullYear()}}
        
      </template>
      </el-table-column>
    <el-table-column label="Link">
      <template #default="scope">
        <el-popover
          placement="top-start"
          :width="200"
          trigger="hover"
          :content="scope.row.link"
        >
          <template #reference>
            <a :href="scope.row.link" target="_blank"><el-button>Ir a {{scope.row.tipo}}</el-button></a>
          </template>
        </el-popover>
      </template>
    </el-table-column>
    <el-table-column label="Acciones">
      <template #default="scope">
        <el-button
          style="border: none; background-color: transparent"
          @click="toggleE(scope.row)"
          ><img src="@/assets/edit.png" alt=""
        /></el-button>
        <el-button
          style="border: none; background-color: transparent"
          @click="handleDelete(scope.row.id)"
          ><img src="@/assets/delete.png" alt=""
        /></el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "tabla",

  methods: {
    ...mapActions({
      addElemento: "addElemento",
      deleteElemento: "deleteElemento",
      updateElemento: "updateElemento",
    }),
    async handleDelete(id) {
      console.log(id + "??");
      const res = await this.deleteElemento(id);
      if (res.message) {
        this.$swal("!Oops", res.message, "error");
      } else {
        this.$swal("Listo!", "Elemento Eliminado", "success");
      }
    },
    toggleA() {
      console.log("tabla");
      this.$emit("toggleAdd");
      this.addActive = true;
      this.editActive = false;
    },
    toggleE(elemento) {
      this.$emit("toggleEdit", elemento);
      this.localData = elemento;
      this.addActive = false;
      this.editActive = true;
      this.upKey++;
    },
    async handleUpdate(data) {
      // console.log('actualizar desde view', data )
      const res = await this.updateElemento(data);
      if (res.message) {
        this.$swal("!Oops", res.message, "error");
      } else {
        this.$swal("Listo!", "Elemento Agregado", "success");
        this.localData = {
          titulo: "",
          descripcion: "",
          link: "",
          file: "",
          tipo: "",
          fecha:""
        };
        this.editActive = false;
      }
    },
  },
  props: {
    elementos: [],
  },
  data() {
    return {
      addActive: false,
      editActive: false,
      localData: {
        titulo: "",
        descripcion: "",
        link: "",
        file: "",
        id: "",
        fecha:""
      },
      upKey: 1,
    };
  },
};
</script>
<style lang="scss" scoped>
.doc {
  font-family: "Poppins";
  font-weight: 800;
  font-size: 24px;
  float: left;
  line-height: 34px;
}
.crear {
  color: #E27367;
  border: 2px solid #E27367;
  background-color: transparent;
  margin-top: 0.8em;
  font-family: "Avenir";
  font-size: 18px;
  border-radius: 15px;
  width: 225px;
}
.verDes{
  margin-left: 45px;
}
.el-table .cell{
  word-break: break-word;
}
</style>